import React, { useState, useEffect } from 'react';
import emailValidator from 'email-validator';
import { TextField } from 'seagull';
import { useStoreActions } from "../../../contexts";
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import { FormContainer, FormTitle, FormDescription, FormFields, VerticalFormFields, SubmitButtonField, Footer, FooterText, FooterLink, ErrorMessage } from "../components/FormComponents";
import { routes } from "../../../constants";
const SentScreen = _ref => {
  let {
    email,
    tryAgain
  } = _ref;
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, {
    testId: "reset-email-sent-msg"
  }, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormTitle, null, "Check Your Email"), /*#__PURE__*/React.createElement(FormDescription, {
    "data-testid": "reset-password-sent-description"
  }, "We've sent password reset instructions to ", email, ", Please open it and click the password reset link."), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(FooterText, null, "Didn't receive an email? "), /*#__PURE__*/React.createElement(FooterLink, {
    onClick: tryAgain
  }, "Wrong email?"))));
};
const FormScreen = _ref2 => {
  let {
    onSuccess
  } = _ref2;
  const {
    api,
    logBI
  } = useStoreActions();
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [emailWasBlurred, setEmailWasBlurred] = useState(false);
  const [resetInProgress, setResetInProgress] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState(null);
  const showEmailFieldError = email !== '' && !isEmailValid && emailWasBlurred;
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, {
    testId: "reset-password-form"
  }, /*#__PURE__*/React.createElement(FormContainer, {
    onChange: () => setResetPasswordError(null),
    onSubmit: async event => {
      logBI(10600, {});
      event.preventDefault();
      setResetInProgress(true);
      try {
        await api.auth.resetPassword(email);
        setResetInProgress(false);
        onSuccess(email);
      } catch (e) {
        setResetInProgress(false);
        setResetPasswordError('Failed to reset password, please try again');
      }
    }
  }, /*#__PURE__*/React.createElement(FormTitle, null, "Reset Password"), /*#__PURE__*/React.createElement(FormDescription, null, "Enter the email address associated with your account and we'll send you a link to reset your password"), /*#__PURE__*/React.createElement(FormFields, null, /*#__PURE__*/React.createElement(VerticalFormFields, null, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    label: "Work email",
    type: "email",
    value: email,
    onChange: event => {
      const value = event.target.value;
      const isValid = emailValidator.validate(value);
      setEmail(value);
      setIsEmailValid(isValid);
    },
    error: showEmailFieldError,
    onBlur: () => setEmailWasBlurred(true),
    "data-testid": "email-input"
  }))), /*#__PURE__*/React.createElement(SubmitButtonField, {
    disabled: !isEmailValid,
    isLoading: resetInProgress,
    "data-testid": "reset-password-button"
  }, "Send a reset link"), resetPasswordError && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "error-msg"
  }, resetPasswordError), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(FooterLink, {
    toInternalLink: routes.login,
    "data-testid": "back-to-login-button"
  }, "Back to sign in"))));
};
export function ResetPasswordScreen() {
  const [email, setEmail] = useState(null);
  useEffect(() => {
    document.title = 'Anchor Reset Password';
  }, []);
  return email ? /*#__PURE__*/React.createElement(SentScreen, {
    email: email,
    tryAgain: () => setEmail(null)
  }) : /*#__PURE__*/React.createElement(FormScreen, {
    onSuccess: setEmail
  });
}